var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loading-block-container"},[_c('RotateSquare'),_c('div',[_c('p',[_vm._v("Aguarde...")])])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }